"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(slot) {
    return ['CLUSTER', 'COUNTKEYSINSLOT', slot.toString()];
}
exports.transformArguments = transformArguments;
